import "./Circle.module.css";
import Navigation from "@/reusable_sections/Header";
import Communautaire from "./sections/Communautaire";
import ProgramTimeline from "./sections/ProgramTimeline";
import Experts from "./sections/Experts";
import Inclusions from "./sections/Inclusions";
import CircleChecklist from "./sections/CircleChecklist";
import CircleProgramOverview from "./sections/CircleProgramOverview";
import Gatherings from "./sections/Gatherings";
import Cercle from "./sections/Cercle";
import InformationsPratiques from "./sections/InformationsPratiques";
import Circles from "./sections/Circles";
import Questions from "./sections/Questions";
import EmotionalClosing from "./sections/EmotionalClosing";
import CircleEnrollmentForm from "./sections/CircleEnrollmentForm";
import Footer from "@/reusable_sections/Footer";
export default function CirclePage() {
  return <div>
      <Navigation />
      
      
      
      <Communautaire />
      <ProgramTimeline />
      <Experts />
      <Inclusions />
      <CircleChecklist />
      <CircleProgramOverview />
      <Gatherings />
      <Cercle />
      <InformationsPratiques />
      <Circles />
      <Questions />
      <EmotionalClosing />
      <CircleEnrollmentForm />
      <Footer />
    </div>;
}